<template>
  <div class="find-pwd">
    <div class="find-main">
      <div class="step1">
        <p class="tips">请填写你的注册邮箱，我们会将重置密码链接发送给你</p>
        <div class="input-cell">
          <!-- <span class="p-txt">手机号</span> -->
          <van-field v-model="mail" :maxlength="50" placeholder="输入你的邮箱地址" />
        </div>
      </div>
      <div class="step2">
        <h3>重置邮件发送成功</h3>
        <p>请在24小时内使用PC电脑版登录邮箱</p>
        <p>187****6074@163.com</p>
        <p>查收邮件链接，激活后可重置密码</p>
      </div>

      <div class="btn">
        <van-button type="primary">确认</van-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  
  .find-pwd {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width:100%;
    height: 100%;
    background: #f5f5f5;
    .find-main {
      .step1 {
        .tips {
          padding:15px 0;
          color:#666;
          font-size: 16px;
          margin:0 15px;
        }
      }
      .step2 {
        h3 {
          margin-top: 35px;
          padding-bottom: 20px;
          text-align: center;
          font-size: 18px;
        }
        p {
          text-align: center;
          color:#666;
          font-size: 16px;
          margin-top: 15px;
        }
      }
      .btn {
          .van-button {
            width:100%;
            font-size:16px;
          }
          margin:0 15px;
          margin-top:20px;
          
        }
    }
  }
</style>
<script>
export default {
  name: "findPwd-module",
  data(){
    return {
      mail:''
    }
  },
  components: {},
  methods: {},
  created() {}
};
</script>
